import React, {useState, useEffect} from 'react';
import {useStores} from "../stores/Context";
import {useHistory} from "react-router-dom";
import LogoSeizoSSvg from "../boiteAOutils/SVG/LogoSeizoSSvg";

const ChoixEntreprise = () => {
    const history = useHistory();
    const {widgetStore, loginStore, workspaceStore} = useStores();
    const [espaces, setEspaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCode, setSelectedCode] = useState("");
    const [loadingSelect, setLoadingSelect] = useState(false);

    useEffect(() => {
        const fetchEspaces = async () => {
            const token = widgetStore.getCookie("user_apiToken");
            try {
                const data = await loginStore.fetchEntreprises(token);
                setEspaces(data);
                // Auto-sélection si un seul espace
                if (data.length === 1) {
                    handleSelect(data[0].code);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchEspaces();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSelect = async (code) => {
        if (!code) return;
        setLoadingSelect(true);
        // Réinitialiser le WorkspaceStore pour éviter d'afficher les workspaces de l'espace précédent
        workspaceStore.reset();
        try {
            await loginStore.loadEntrepriseData(code);
            history.push('/app');
        } catch (err) {
            console.error("Erreur lors du chargement de l'espace :", err);
            setLoadingSelect(false);
        }
    };

    if (loading || loadingSelect) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--SEIZO-bg, #F4F6F9)',
                gap: '1rem',
            }}>
                <LogoSeizoSSvg width="48" height="60"/>
                <p style={{
                    color: 'var(--SEIZO-dark, #002335)',
                    fontFamily: 'Nunito, sans-serif',
                    fontSize: '16px',
                    fontWeight: 600,
                }}>
                    {loadingSelect ? 'Chargement de votre espace...' : 'Chargement...'}
                </p>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--SEIZO-bg, #F4F6F9)',
            }}>
                <p style={{ color: '#e53e3e', fontFamily: 'Nunito, sans-serif' }}>{error}</p>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: 'var(--SEIZO-bg, #F4F6F9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
        }}>
            <div style={{
                background: '#fff',
                borderRadius: '20px',
                boxShadow: '0 8px 40px rgba(0,35,53,0.12)',
                padding: '3rem 2.5rem',
                maxWidth: '480px',
                width: '100%',
                textAlign: 'center',
            }}>
                {/* Logo */}
                <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center' }}>
                    <LogoSeizoSSvg width="48" height="60"/>
                </div>

                <h1 style={{
                    color: 'var(--SEIZO-dark, #002335)',
                    fontFamily: 'Nunito, sans-serif',
                    fontSize: '1.75rem',
                    fontWeight: 800,
                    marginBottom: '0.5rem',
                }}>
                    Choisissez votre espace
                </h1>
                <p style={{
                    color: '#6b7280',
                    fontFamily: 'Nunito, sans-serif',
                    fontSize: '14px',
                    marginBottom: '2rem',
                }}>
                    Vous avez accès à {espaces.length} espaces. Sélectionnez celui sur lequel vous souhaitez travailler.
                </p>

                {/* Liste des espaces */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {espaces.map((espace) => (
                        <button
                            key={espace.code}
                            onClick={() => handleSelect(espace.code)}
                            style={{
                                background: selectedCode === espace.code
                                    ? 'var(--SEIZO-bleu, #00B0FF)'
                                    : '#F4F6F9',
                                border: selectedCode === espace.code
                                    ? '2px solid var(--SEIZO-bleu, #00B0FF)'
                                    : '2px solid transparent',
                                borderRadius: '12px',
                                padding: '1rem 1.5rem',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '1rem',
                                transition: 'all 0.2s',
                                textAlign: 'left',
                                width: '100%',
                            }}
                            onMouseEnter={e => {
                                if (selectedCode !== espace.code) {
                                    e.currentTarget.style.background = '#e8f4ff';
                                    e.currentTarget.style.borderColor = 'var(--SEIZO-bleu, #00B0FF)';
                                }
                            }}
                            onMouseLeave={e => {
                                if (selectedCode !== espace.code) {
                                    e.currentTarget.style.background = '#F4F6F9';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }
                            }}
                        >
                            {/* Icône espace */}
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '10px',
                                background: 'var(--SEIZO-bleu, #00B0FF)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 42 41" fill="none">
                                    <path d="M2.6665 7.48059H16.8332L22.6665 12.4806H39.3332V35.8139H2.6665V7.48059Z"
                                          stroke="white" strokeWidth="3.5"/>
                                </svg>
                            </div>
                            <div>
                                <div style={{
                                    color: 'var(--SEIZO-dark, #002335)',
                                    fontFamily: 'Nunito, sans-serif',
                                    fontSize: '15px',
                                    fontWeight: 700,
                                }}>
                                    {espace.libelle}
                                </div>
                                <div style={{
                                    color: '#9ca3af',
                                    fontFamily: 'Nunito, sans-serif',
                                    fontSize: '12px',
                                    marginTop: '2px',
                                }}>
                                    {espace.code}
                                </div>
                            </div>
                            <div style={{ marginLeft: 'auto', color: 'var(--SEIZO-bleu, #00B0FF)' }}>
                                →
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChoixEntreprise;
